require('./brokerInternalTransferFundsView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const BrokerInternalTransferFunds = require('components/broker/brokerInternalTransferFunds/brokerInternalTransferFunds');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');

// @utils
const { scrollToTop } = require('commonsUtilities/scrollUtils');
import { recordLinkV2 } from "utilities/tagging";

// @actions
const brokerInternalTransferFundsActions = require('actions/brokerInternalTransferFunds');
const brokerStocksByTypeActions = require('actions/brokerStocksByType');
const investmentFundsActions = require('actions/investmentFunds');
const brokerMiFIDProductsAction = require('mifid/actions/brokerMiFIDProducts');
const preContractualMailActions = require('actions/preContractualMailInfo');
const profileActions = require('actions/profile');
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');
import {
    removeLegalDocumentation,
} from 'actions/brokerLegalDocumentation';
// @ CC Actions
const PrinterActions = require('actions/contactCenter/printer');

// @constants
const {
    MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND,
    MYPROFILE_BROKER_URL,
    FIRST_STEP,
} = require('constants/index');

const {
    brokerTransferFundsTags
} = require('../../../utilities/taggingInfo/brokerTransferFundsTags');

class BrokerInternalTransferFundsView extends React.Component {

    constructor(props) {
        super(props);

        this.handleFinish = this.handleFinish.bind(this);
        this.handlePartialTrasferTypeChange = this.handlePartialTrasferTypeChange.bind(this);
        this.onSetAmountChange = this.onSetAmountChange.bind(this);
        this.isReadyToLeaveOperation = this.isReadyToLeaveOperation.bind(this);
    }

    componentDidMount() {
        this.props.outdateMyInvestments();
        this.props.getStocksByType();
        scrollToTop();
    }

    componentWillUnmount() {
        const {
            removeLegalDocumentation,
            onResetInvestmentFunds,
        } = this.props
        onResetInvestmentFunds();
        removeLegalDocumentation()
    }

    onSetAmountChange(value, partialType) {
        this.props.setAmount(value, partialType);
    }

    buildDestinationFunds() {
        const { immBrokerMyInvestments, immBrokerInternalTransferFunds } = this.props;
        const originFund = immBrokerInternalTransferFunds.getIn(['steps', 0, 'originFund']);
        const isinFromNewFund = immBrokerInternalTransferFunds.get('isinFromNewFund')
        if(isinFromNewFund !== '') {
            return immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).filter(
                destinationFund => destinationFund.get('isin') === isinFromNewFund
            );
        }

        return immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).filter(
            destinationFund => destinationFund.get('id') !== originFund
        );
    }

    buildHeader() {
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText('breadcrumb-brokerInternalTransferFund'),
                url: MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND,
            }
        ];

        return (
            <OKCover size="medium" section="broker">
                <OKHeaderSubPage
                    breadcrumbConfig={mappingBreadcrumb}
                    isSubtitleLeftCapital={false}
                    finalTitle={getFinalTitle('brokerInternalTransferFund-pageTitle')}
                >
                </OKHeaderSubPage>
            </OKCover>
        );

    }

    handleCancel() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    handleFinish() {
        this.props.internalTransferConf(this.props.history);
    }

    handlePartialTrasferTypeChange(value) {
        const { immBrokerInternalTransferFunds } = this.props;
        const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);
        this.props.onChangePartialTransferType(value);
        recordLinkV2({
            ...brokerTransferFundsTags(fundType, value)
        })
    }

    isReadyToLeaveOperation() {
        const {
            immBrokerInternalTransferFunds,
        } = this.props;

        return immBrokerInternalTransferFunds.get('disableLeavingModal');
    }

    onHandleChange(type) {
        const { handleChangeType, immBrokerInternalTransferFunds } = this.props;
        const fundType = immBrokerInternalTransferFunds.getIn(['steps', FIRST_STEP, 'fundType']);

        handleChangeType(type);
        recordLinkV2({
            ...brokerTransferFundsTags(fundType, type)
        })
    }

    render() {
        const {
            setVisibleStep,
            setOriginFund,
            validateStep,
            setWillCancel,
            immBrokerInternalTransferFunds,
            immBrokerMyInvestments,
            setDestinationFund,
            immFunds,
            getPreMotor,
            immAccounts,
            getMorningStarScreener,
            immInvestmentFunds,
            onDisclaimerChecked,
            onSelectFundsStepNextClick,
            immBrokerMiFIDProducts,
            onFetchBrokerMiFIDProduct,
            inputSearchFundSelected,
            onChangeFundType,
            immProfileFields,
            immPreContractualMail,
            legalYesNoOptionChange,
            resetLegalInformation,
            sendEmail,
            resetEmailState,
            refreshEmailAddress,
            getInterveners,
            setEmptyState,
            hideModalSelectFunds,
            immFlagBasedFeatures,
            validateDestinationFundDocuments,
            validateEconomicReport,
            immSignaturePattern,
            setOriginContributionFundStep,
            setContributionAmount,
            setContributionPeriodicity,
            setContributionValidityDateValue,
            setContributionDatePickerError,
            skipContributionStep,
            setAproxAmountParticipations,
        } = this.props;

        const header = this.buildHeader();
        const immDestinationFunds = this.buildDestinationFunds();

        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        const isFetchingContributionsList = immBrokerMyInvestments.getIn(['fundsContributionsList', 'isFetching']);
        
        const isin = immBrokerInternalTransferFunds.getIn(['steps', 1, 'contributionFunds', 'isin']);
        const customMinimumPurchaseAmount = {
            amount: immInvestmentFunds.getIn(['steps', 0, 'investmentFunds', 'customMinimumPurchaseAmount', 'additionalSubscriptionAmount'], '0'),
            currency: immInvestmentFunds.getIn(['steps', 0, 'investmentFunds', 'customMinimumPurchaseAmount', 'currency']),
        };
        const contributionAmount = immBrokerInternalTransferFunds.getIn(['steps', 1, 'amount']);
        const contributionAmountErrorState = immBrokerInternalTransferFunds.getIn(['steps', 1, 'amountErrorState']);
        const contributionAmountErrorMsg = immBrokerInternalTransferFunds.getIn(['steps', 1, 'amountErrorMsg']);
    
        const contributionPeriodicityError = immBrokerInternalTransferFunds.getIn(['steps', 1, 'periodicityError']);
        const contributionPeriodicityErrorMsg = immBrokerInternalTransferFunds.getIn([
          'steps',
          1,
          'periodicityErrorMsg',
        ]);
        const contributionPeriodicityValue = immBrokerInternalTransferFunds.getIn(['steps', 1, 'periodicityValue']);
        const contributionPeriodicityOptions = immBrokerInternalTransferFunds.getIn([
          'steps',
          1,
          'periodicityOptions',
        ]);
        const contributionSelectedDate = immBrokerInternalTransferFunds.getIn(['steps', 1, 'selectedDate']);
        const contributionMinDate = immBrokerInternalTransferFunds.getIn(['steps', 1, 'minDate']);
        
        const content = immBrokerMyInvestments.get('isFetching') || isFetchingContributionsList ? <LoadingSection /> : (
            <div className="broker-internal-transfer-funds-view__body">
                <div className="row">
                    <BrokerInternalTransferFunds
                        immSignaturePattern={immSignaturePattern}
                        validateStep={validateStep}
                        setVisibleStep={setVisibleStep}
                        setWillCancel={setWillCancel}
                        onCancel={() => this.handleCancel()}
                        onFinish={this.handleFinish}
                        handleSetAmount={this.onSetAmountChange}
                        handleChangeType={(e) => this.onHandleChange(e)}
                        immBrokerMyInvestments={immBrokerMyInvestments}
                        immDestinationFunds={immDestinationFunds}
                        immBrokerInternalTransferFunds={immBrokerInternalTransferFunds}
                        setOriginFundChange={setOriginFund}
                        setDestinationFund={setDestinationFund}
                        getPreMotor={getPreMotor}
                        immFunds={immFunds}
                        immAccounts={immAccounts}
                        getMorningStarScreener={getMorningStarScreener}
                        immInvestmentFunds={immInvestmentFunds}
                        onDisclaimerChecked={onDisclaimerChecked}
                        onSelectFundsStepNextClick={onSelectFundsStepNextClick}
                        immBrokerMiFIDProducts={immBrokerMiFIDProducts}
                        onChangePartialTransferType={this.handlePartialTrasferTypeChange}
                        onFetchBrokerMiFIDProduct={onFetchBrokerMiFIDProduct}
                        inputSearchFundSelected={inputSearchFundSelected}
                        onChangeFundType={onChangeFundType}
                        immProfileFields={immProfileFields}
                        immPreContractualMail={immPreContractualMail}
                        legalYesNoOptionChange={legalYesNoOptionChange}
                        resetLegalInformation={resetLegalInformation}
                        sendEmail={sendEmail}
                        resetEmailState={resetEmailState}
                        refreshEmailAddress={refreshEmailAddress}
                        getInterveners={getInterveners}
                        setEmptyState={setEmptyState}
                        hideModalSelectFunds={hideModalSelectFunds}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        validateDestinationFundDocuments={validateDestinationFundDocuments}
                        validateEconomicReport={validateEconomicReport}
                        
                        setOriginContributionFundStep={setOriginContributionFundStep}
                        isin={isin}
                        customMinimumPurchaseAmount={customMinimumPurchaseAmount}
                        amount={contributionAmount}
                        amountErrorState={contributionAmountErrorState}
                        amountErrorMsg={contributionAmountErrorMsg}
                        periodicityError={contributionPeriodicityError}
                        periodicityErrorMsg={contributionPeriodicityErrorMsg}
                        periodicityValue={contributionPeriodicityValue}
                        periodicityOptions={contributionPeriodicityOptions}
                        selectedDate={contributionSelectedDate}
                        minDate={contributionMinDate}
                        onStepChange={()=>{}}
                        setAmount={setContributionAmount}
                        setPeriodicity={setContributionPeriodicity}
                        setValidityDate={setContributionValidityDateValue}
                        setDatePickerError={setContributionDatePickerError}
                        skipContributionStep={skipContributionStep}
                        setAproxAmountParticipations={setAproxAmountParticipations}
                    />
                </div>
            </div>
        );
        return (
            <div className="broker-internal-transfer-funds-view">
                {header}
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={this.isReadyToLeaveOperation}
                />
                {content}
            </div>
        );
    }
}

BrokerInternalTransferFundsView.propTypes = {
    setVisibleStep: PropTypes.func.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setAmount: PropTypes.func.isRequired,
    handleChangeType: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immBrokerInternalTransferFunds: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    setOriginFund: PropTypes.func.isRequired,
    setDestinationFund: PropTypes.func.isRequired,
    immFunds: PropTypes.object.isRequired,
    internalTransferConf: PropTypes.func.isRequired,
    getPreMotor: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    resetOperation: PropTypes.func.isRequired,
    getMorningStarScreener: PropTypes.func.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired,
    onDisclaimerChecked: PropTypes.func.isRequired,
    onSelectFundsStepNextClick: PropTypes.func.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    onChangePartialTransferType: PropTypes.func.isRequired,
    onFetchBrokerMiFIDProduct: PropTypes.func.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    inputSearchFundSelected: PropTypes.func.isRequired,
    onChangeFundType: PropTypes.func.isRequired,
    outdateMyInvestments: PropTypes.func.isRequired,
    hideModalSelectFunds: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    onResetInvestmentFunds: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    legalYesNoOptionChange: PropTypes.func.isRequired,
    resetLegalInformation: PropTypes.func.isRequired,
    sendEmail: PropTypes.func.isRequired,
    resetEmailState: PropTypes.func.isRequired,
    refreshEmailAddress: PropTypes.func.isRequired,
    getInterveners: PropTypes.func.isRequired,
    setEmptyState: PropTypes.func.isRequired,
    removeLegalDocumentation: PropTypes.func.isRequired,
    validateDestinationFundDocuments: PropTypes.func.isRequired,
    validateEconomicReport: PropTypes.func.isRequired,
};

module.exports.constructor = BrokerInternalTransferFundsView;
module.exports.BrokerInternalTransferFundsView = connect(state => ({
    immBrokerMyInvestments: state.brokerMyInvestments,
    immBrokerInternalTransferFunds: state.brokerInternalTransferFunds,
    immFunds: state.brokerWallets.get('fundsList'),
    immAccounts: state.accounts,
    immInvestmentFunds: state.investmentFunds,
    immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
    immBrokerMiFIDProducts: state.brokerMiFIDProducts,
    immGlobalPosition: state.globalPosition,
    immProfileFields: state.profile,
    immSignaturePattern: state.signaturePattern,
    immPreContractualMail: state.preContractualMail,
    immFlagBasedFeatures: state.flagBasedFeatures,
}), {
        validateStep: brokerInternalTransferFundsActions.validateStep,
        resetPrintedIndicators: PrinterActions.resetPrintedIndicators,
        setVisibleStep: brokerInternalTransferFundsActions.setVisibleStep,
        setWillCancel: brokerInternalTransferFundsActions.setWillCancel,
        hireSubscription: brokerInternalTransferFundsActions.hireSubscription,
        setAmount: brokerInternalTransferFundsActions.setAmount,
        setWillLeave: brokerInternalTransferFundsActions.setWillLeave,
        onSetAmountChange: brokerInternalTransferFundsActions.setAmount,
        handleChangeType: brokerInternalTransferFundsActions.changeType,
        getStocksByType: brokerStocksByTypeActions.getStocksByType,
        setOriginFund: brokerInternalTransferFundsActions.setOriginFund,
        setOriginContributionFundStep: brokerInternalTransferFundsActions.setOriginContributionFundStep,
        setDestinationFund: brokerInternalTransferFundsActions.setDestinationFund,
        internalTransferConf: brokerInternalTransferFundsActions.internalTransferConf,
        getPreMotor: brokerInternalTransferFundsActions.getPreMotor,
        resetOperation: brokerInternalTransferFundsActions.reset,
        getMorningStarScreener: investmentFundsActions.getMorningStarScreener,
        onDisclaimerChecked: brokerInternalTransferFundsActions.toggleDisclaimer,
        onSelectFundsStepNextClick: brokerInternalTransferFundsActions.stepSelectFundsValidation,
        onChangePartialTransferType: brokerInternalTransferFundsActions.setPartialTransferType,
        onFetchBrokerMiFIDProduct: brokerMiFIDProductsAction.fetchMiFIDProduct,
        onChangeFundType: brokerInternalTransferFundsActions.onChangeFundType,
        outdateMyInvestments: BrokerMyInvestmentsActions.outdateMyInvestments,
        hideModalSelectFunds: brokerInternalTransferFundsActions.hideModalSelectFunds,
        inputSearchFundSelected: brokerInternalTransferFundsActions.inputSearchFundSelected,
        reset: brokerInternalTransferFundsActions.reset,
        onResetInvestmentFunds: investmentFundsActions.reset,
        legalYesNoOptionChange: brokerInternalTransferFundsActions.legalYesNoOptionChange,
        resetLegalInformation: brokerInternalTransferFundsActions.resetLegalInformation,
        sendEmail: preContractualMailActions.sendBrokerPreContractualMailV2,
        resetEmailState: preContractualMailActions.resetPrecontractualMail,
        refreshEmailAddress: profileActions.requestProfile,
        getInterveners: brokerInternalTransferFundsActions.getInterveners,
        setEmptyState: brokerInternalTransferFundsActions.setEmptyState,
        validateDestinationFundDocuments: brokerInternalTransferFundsActions.validateDestinationFundDocuments,
        validateEconomicReport: brokerInternalTransferFundsActions.validateEconomicReport,
        removeLegalDocumentation: removeLegalDocumentation,

        setOriginContributionFundStep: brokerInternalTransferFundsActions.setOriginContributionFundStep,
        setContributionAmount: brokerInternalTransferFundsActions.setContributionAmount,
        validateContributionStep: brokerInternalTransferFundsActions.validateContributionStep,
        setContributionPeriodicity: brokerInternalTransferFundsActions.setContributionPeriodicity,
        setContributionValidityDateValue: brokerInternalTransferFundsActions.setContributionValidityDateValue,
        setContributionAccountNumber: brokerInternalTransferFundsActions.setContributionAccountNumber,
        setPreviousContributions: brokerInternalTransferFundsActions.setPreviousContributions,
        setContributionDatePickerError: brokerInternalTransferFundsActions.setContributionDatePickerError,
        skipContributionStep: brokerInternalTransferFundsActions.skipContributionStep,
        setAproxAmountParticipations: brokerInternalTransferFundsActions.setAproxAmountParticipations
    })(withRouter(BrokerInternalTransferFundsView));
